import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=5cdb2b58&scoped=true&"
var script = {}
import style0 from "@/assets/scss/footer.scss?vue&type=style&index=0&id=5cdb2b58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdb2b58",
  null
  
)

export default component.exports